import React from 'react';
import cx from 'classnames';
import { memoize } from 'lodash';
import { Global, css } from '@emotion/react';
import '%/node_modules/placeholder-loading/src/scss/placeholder-loading.scss';

const getBaseUnit = memoize(() => 100 / 12);

const getColFlexPercentage = memoize((size) =>
  Math.floor(size * getBaseUnit())
);

const oddColSizesStyles = css`
  .ph-item {
    .ph-col-1 {
      flex: 0 0 ${getColFlexPercentage(1)}%;
      padding-right: 0;
    }

    .ph-col-3 {
      flex: 0 0 ${getColFlexPercentage(3)}%;
    }

    .ph-col-5 {
      flex: 0 0 ${getColFlexPercentage(5)}%;
    }

    .ph-col-7 {
      flex: 0 0 ${getColFlexPercentage(7)}%;
    }

    .ph-col-9 {
      flex: 0 0 ${getColFlexPercentage(9)}%;
    }

    .ph-col-11 {
      flex: 0 0 ${getColFlexPercentage(11)}%;
    }
  }
`;

export type ItemProps = Pick<
  React.HTMLAttributes<HTMLDivElement>,
  'children' | 'style' | 'className'
>;

export function Item({ children, style, className }: ItemProps) {
  return (
    <>
      <div
        className={cx('ph-item', className)}
        style={{
          padding: '15px 0 0',
          border: 'none',
          marginLeft: -15,
          marginBottom: 0,
          ...style,
        }}
      >
        {children}
      </div>
      <Global styles={oddColSizesStyles} />
    </>
  );
}

export type RowProps = Pick<
  React.HTMLAttributes<HTMLDivElement>,
  'children' | 'style'
> & { className?: string };

export function Row({ children, style, className = '' }: RowProps) {
  return (
    <div className={`ph-row ${className}`} style={style}>
      {children}
    </div>
  );
}

export interface ColProps
  extends Pick<React.HTMLAttributes<HTMLDivElement>, 'children' | 'style'> {
  size: number;
  big?: boolean;
  empty?: boolean;
  className?: string;
}

export function Col({
  size,
  children,
  style,
  big = false,
  empty = false,
  className = '',
}: ColProps) {
  return (
    <div
      className={cx(`ph-col-${size} ${className}`, { big, empty })}
      style={style}
    >
      {children}
    </div>
  );
}

export interface AvatarProps
  extends Pick<React.HTMLAttributes<HTMLDivElement>, 'style' | 'className'> {
  size: number;
}

export function Avatar({ size = 60, style, className }: AvatarProps) {
  return (
    <div
      className={cx('ph-avatar', className)}
      style={{
        ...style,
        maxHeight: size,
        maxWidth: size,
        minHeight: size,
        minWidth: size,
        height: size,
        width: size,
      }}
    />
  );
}

export type PictureProps = Pick<
  React.HTMLAttributes<HTMLDivElement>,
  'className' | 'style'
>;

export function Picture({ className, style }: PictureProps) {
  return <div className={cx('ph-picture', className)} style={style} />;
}
